import { defineMessages } from 'react-intl';

export default defineMessages({
  title: {
    id: 'app.shopDetails.pages.shopInfo.title',
    defaultMessage: 'Información',
  },
  noDelivery: {
    id: 'app.shopDetails.pages.shopInfo.nodelivery',
    defaultMessage: 'No hay delivery',
  },
  generalInfoTitle: {
    id: 'app.shopDetails.pages.shopInfo.generalInfo',
    defaultMessage: 'Información general',
  },
  generalInfoTitleCompanyName: {
    id: 'app.shopDetails.pages.shopInfo.generalInfo.companyName',
    defaultMessage: 'Razón social: {companyName}',
  },
  generalInfoCompanyNumber: {
    id: 'app.shopDetails.pages.shopInfo.generalInfo.companyNumber',
    defaultMessage: 'RUT: {companyNumber}',
  },
  generalInfoCompanyAddress: {
    id: 'app.shopDetails.pages.shopInfo.generalInfo.address',
    defaultMessage: 'Dirección: {street} {doorNumber}',
  },
  generalInfoBromatologyCode: {
    id: 'app.shopDetails.pages.shopInfo.generalInfo.bromatologyCode',
    defaultMessage: 'Habilitación bromatológica n°: {bromatologyCode}',
  },
});
